import { render, staticRenderFns } from "./EquitiesMessage.vue?vue&type=template&id=6b4cebad&scoped=true&"
import script from "./EquitiesMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./EquitiesMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EquitiesMessage.vue?vue&type=style&index=0&id=6b4cebad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cebad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4cebad')) {
      api.createRecord('6b4cebad', component.options)
    } else {
      api.reload('6b4cebad', component.options)
    }
    module.hot.accept("./EquitiesMessage.vue?vue&type=template&id=6b4cebad&scoped=true&", function () {
      api.rerender('6b4cebad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/components/orderDetail/EquitiesMessage.vue"
export default component.exports